import { useSchedulingQuery as useQuery } from "./useSchedulingQuery";
import { listAllAppointments } from "../../components/api/Scheduling/appointments";
import { onError } from "./onError";

export const appointmentKeys = {
  list: (organizationRef, filters) => ["scheduling-appointments", organizationRef, filters],
};

export function useAppointmentsQuery({
  organizationRef,
  scope,
  excludedOrganizationRefs,
  practitionerRef,
  patientRef,
  scheduleId,
  serviceCategoryId,
  status,
  startsAt,
  endsAt,
  onSuccess,
  enabled = true,
  refetchInterval,
}) {
  const filters = { scope, excludedOrganizationRefs, practitionerRef, patientRef, scheduleId, serviceCategoryId, status, startsAt, endsAt };
  return useQuery(
    appointmentKeys.list(organizationRef, filters),
    ({ signal, consistency }) => listAllAppointments({ organizationRef, ...filters, limit: 500, signal, consistency }),
    {
      enabled: !!organizationRef && enabled,
      keepPreviousData: false,
      staleTime: 30000, refetchOnWindowFocus: false, retry: false,
      onSuccess,
      onError,
      refetchInterval: refetchInterval ? Math.max(30000, refetchInterval) : false,
      refetchIntervalInBackground: false,
    }
  );
}
